import {
  GetTimeSeriesViewRequest,
  Scale,
  TimeSeries,
  View,
  XAxis,
} from 'generated/leaderboard-client';

import { EntityModelConverter } from '@neptune/shared/entity-domain';
import { RunsLineage } from '@neptune/shared/leaderboard-domain';

import { getTableWidgetVisibleStepCount, type TableWidgetOptions } from './table-configuration';

export type TableWidgetSeries = {
  attributePath: string;
  parentId: string;
  parentType: 'run';
  id: string;
  label: string;
  lineageEntityType: 'RUN' | 'EXPERIMENT';
  includePreview: boolean;
  normalizeToFirstValue: boolean;
  entityOrderKey?: number;
  metricOrderKey?: number;
};

const DEFAULT_MAX_UNIQUE_X = 2;

export function createTableWidgetSeriesRequest({
  series,
  lineage,
  stepRange,
}: {
  series: TableWidgetSeries[];
  lineage: RunsLineage;
  stepRange?: TableWidgetOptions['stepRange'];
}): GetTimeSeriesViewRequest {
  const maxUniqueX = Math.max(
    getTableWidgetVisibleStepCount(stepRange) ?? DEFAULT_MAX_UNIQUE_X,
    DEFAULT_MAX_UNIQUE_X,
  );
  const view: View = {
    ...(stepRange?.start !== undefined || stepRange?.end !== undefined
      ? {
          pointFilters: {
            stepRange: {
              from: stepRange?.start,
              to: stepRange?.end,
            },
          },
        }
      : {}),
    maxUniqueX,
    plotMode: { line: {} },
    xscale: scaleFromDomainToApi(),
    yscale: scaleFromDomainToApi(),
  };

  const xaxis: XAxis = {
    steps: {},
  };

  return {
    request: {
      view,
      series: series.map((item) => tableWidgetSeriesFromDomainToApi(item, lineage)),
      xaxis,
    },
  };
}

function scaleFromDomainToApi(): Scale {
  return { linear: {} };
}

function tableWidgetSeriesFromDomainToApi(
  { attributePath, parentId, parentType, lineageEntityType, includePreview }: TableWidgetSeries,
  lineage: RunsLineage,
): TimeSeries {
  return {
    attribute: attributePath,
    holder: {
      identifier: parentId,
      type: EntityModelConverter.entityTypeToHolderType(parentType),
    },
    includePreview,
    lineage,
    lineageEntityType,
  };
}
